import { supportsHover as supportsHoverHelper } from '@bridebook/aura';
import { TimeInputDesktop } from './time-input-desktop';
import { TimeInputMobile } from './time-input-mobile';
import type { TimeInputProps } from './types';

/** Router component — picks mobile or desktop time input based on device capability. */
export const TimeInput = ({ isTouchDevice: isTouchDeviceProp, ...allProps }: TimeInputProps) => {
  const isTouchDevice = isTouchDeviceProp ?? !supportsHoverHelper();

  if (isTouchDevice) {
    return <TimeInputMobile {...allProps} />;
  }

  return <TimeInputDesktop {...allProps} />;
};
